<div class="public-shell" [class.public-shell--jetcrete]="brand.id === 'jetcrete'">
  @if (brand.showLanguageSelector) {
    <div class="public-shell__toolbar">
      <div class="public-shell__language">
        <app-language-selector />
      </div>
    </div>
  }

  <div class="public-shell__card">
    <div class="public-shell__brand-panel" aria-hidden="true">
      <img
        class="public-shell__brand-pattern"
        src="images/illustrations/21mt-pattern-background.png"
        alt=""
      />
    </div>
    <main class="public-shell__content">
      <router-outlet />
    </main>
  </div>

  <footer class="public-shell__footer">
    {{ 'layout.publicFoot.content' | translate: { year: year } }}
  </footer>
</div>
